<form [formGroup]="form1" (ngSubmit)="create()" *ngIf="storesId else notStore">
    <div class="card">
      <div class="card-header text-center" style="text-transform: uppercase">
        VISITANTE
      </div>
      <div class="card-body">
        <div class="row gx-3 mb-3">
          <div class="col-md-4 col-sm-12">
            <label class="small mb-1" for="name">Nombre</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="name" uppercaseInput />
            </div>
          </div>
          <div class="col-md-8 col-sm-12">
            <label class="small mb-1" for="lastname">Apellidos</label>
            <div class="input-group">
              <input type="text" class="form-control text-capitalize" formControlName="lastname" uppercaseInput />
            </div>
          </div>
          <div class="col-md-8">
            <label class="small mb-1" for="rut">RUT/IDENTIFICACIÓN</label>
            <div class="input-group">
              <span class="input-group-text" id="basic-addon1"><i class="fa-solid fa-id-card"></i></span>
              <input type="text" class="form-control" formControlName="rut" uppercaseInput
                (keyup)="onFormatRut($event)" />
            </div>
          </div>
          <div class="col-md-4">
            <label class="small mb-1" for="date_in"> INGRESO</label>
            <div class="input-group">
                <input type="date" class="form-control" formControlName="date_ing" />
            </div>
          </div>
        </div>
        <button class="btn btn-primary w-100" type="submit">CREAR</button>
      </div>
    </div>
  </form>
  <ng-template #notStore>
    <h2>No se recibio el identificador de la bodega, que se debe asociar</h2>
  </ng-template>